namespace Solovis.UI.Buttons {

    /**
     * ButtonGroup is a UI element used to group Buttons together.
     * options:
     * container: container div for the button group
     * 
     * cssRules: array of objects of type
     *   {
     *       rule: name of the css rule to be added
     *       value: value applied to the css rule
     *   }
     */
    export class ButtonGroup {

        public _cssRules;
        public _container;
        public _buttonNameToButtonMap;
        

        constructor(options) {
            this._cssRules = options.cssRules ? options.cssRules : null;
            this._container = options.container;
            this._buttonNameToButtonMap = {};

            this._setupContainer();
        }


        public _setupContainer() {
            var self = this;

            this._container
                .addClass("btn-group")
                .attr("role", "group");

            if (this._cssRules) {
                Solovis.UI.DomHelper.applyCssRules(this._container, this._cssRules);
            }
        }

        /**
         *  Retrieve ButtonGroup button by name. Does not throw exception if button for name is not found.
         */
        public tryGetButtonByName(name) {
            var item = this._buttonNameToButtonMap[name];
            if (item) {
                return item;
            }
            else {
                return null;
            }
        }

        /**
         *  Retrieve ButtonGroup button by name. Throws exception if button for name is not found.
         */
        public getButtonByName(name) {            
            var item = this.tryGetButtonByName(name);
            if (item) {
                return item;
            }
            else {
                throw "Solovis.UI.Buttons.ButtonGroup: No button found for name: " + name;
            }
        }

        /**
         * Remove ButtonGroup button by name. Does not throw exception if button for name is not found.
         */
        public removeButtonByName(name) {            
            var item = this.tryGetButtonByName(name);
            if (item) {
                var elementToRemove = item.getElement();
                if (elementToRemove) {
                    elementToRemove.remove();
                    this._buttonNameToButtonMap[name] = null;
                }
            }
        }

        /*
         * options:
         * name: name of the button, 
         * buttonOptions: object.  If it has an actions property, the button will be a DropdownButton.  Otherwise it will create a standard button.
         * index: index at which to place the button in the group
         * 
         */
        public addButton(options) {
            var buttonOptions = options.buttonOptions;

            var button = null;

            if (buttonOptions.actions) {
                button = new (Solovis as any).UI.Buttons.DropdownButton(buttonOptions);
            }
            else {
                button = new (Solovis as any).UI.Buttons.Button(buttonOptions);
            }

            this._buttonNameToButtonMap[options.name] = button;
            this._addItemElement(button.getElement(), options.index);
        }

        public _addItemElement(element, index) {
            if (index < 0) {
                console.log("Solovis.UI.Buttons.ButtonGroup: invalid index.");
                return;
            }
            if (!element.html) {
                console.log("Solovis.UI.Buttons.ButtonGroup: invalid element.");
                return;
            }

            element.css("display", "inline-block");
            if (Solovis.isNotNull(index)) {
                var length = this._container.children().length;

                if (!length) {
                    index = 0;
                }
                if (index >= length) {
                    this._container.append(element);
                }
                else {
                    this._container.children().eq(index).before(element);
                }

            }
            else {
                this._container.append(element);
            }
        }

        public length() {
            return this._container.children().length;
        }

        public getElement() {
            return this._container;
        }

        public showButtonByName(name, visible) {
            var button = this.tryGetButtonByName(name);
            if (button) {
                var buttonElement = button.getElement();

                buttonElement.toggle(visible);
            }
        }
    }

}
